import { useId } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import type { Customer } from '@features/customers/types/customers.types';
import { customerContactNumber } from '../../utils/customerContactNumber';
import { formatAddress } from '../../utils/formatAddress';
import { SummaryDetailList } from './SummaryDetailList';

interface Props {
    customer: Customer | null | undefined;
}

export function QuoteCustomerPanel({ customer }: Props) {
    const headingId = useId();
    const contact = customerContactNumber(customer);

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>Customer</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    <SummaryDetailList
                        emptyMessage="No customer has been selected."
                        fields={[
                            {
                                label: 'Name',
                                value: customer ? `${customer.forename} ${customer.surname}` : 'Not selected',
                            },
                            { label: 'Business name', value: customer?.business_name },
                            { label: 'Address', value: formatAddress(customer), fullWidth: true },
                            { label: 'Email', value: customer?.email ?? 'Not provided' },
                            { label: contact.label, value: contact.value, testId: 'summary-contact-number' },
                        ]}
                    />
                </section>
            </CardContent>
        </Card>
    );
}
